/*
 * @Date: 2021-11-11 14:47:59
 * @LastEditTime: 2021-11-18 15:51:52
 * @LastEditors: Please set LastEditors
 * @Description: epas网关封装，依赖crypto和string-builder package
 */
import crypto from "crypto";
import Vue from "vue";

const StringBuilder = require("string-builder");
const GATEWAY_ENCRYPT_CONFIG = (window.shield || {}).ShieldConfig;

const SEPARATOR = "|";

class FlyCrypto {
  constructor(config) {
    this._byteToHex = [];
    this.config = config;
    this.innitByteToHex();
  }
  getConfig() {
    return this.config;
  }
  innitByteToHex() {
    for (let i = 0; i < 256; i++) {
      this._byteToHex[i] = (i + 0x100).toString(16).substr(1);
    }
  }
  _rng() {
    const _rnds = new Array(16);
    for (let i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) {
        r = Math.random() * 0x100000000;
      }
      _rnds[i] = (r >>> ((i & 0x03) << 3)) & 0xff;
    }

    return _rnds;
  }
  unparse(buf) {
    let i = 0;
    const bth = this._byteToHex;
    return (
      bth[buf[i++]] +
      bth[buf[i++]] +
      bth[buf[i++]] +
      bth[buf[i++]] +
      "-" +
      bth[buf[i++]] +
      bth[buf[i++]] +
      "-" +
      bth[buf[i++]] +
      bth[buf[i++]] +
      "-" +
      bth[buf[i++]] +
      bth[buf[i++]] +
      "-" +
      bth[buf[i++]] +
      bth[buf[i++]] +
      bth[buf[i++]] +
      bth[buf[i++]] +
      bth[buf[i++]] +
      bth[buf[i++]]
    );
  }
  creatUuid() {
    const rnds = this._rng();
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;
    return this.unparse(rnds);
  }
  buildStringToSign(headValues) {
    const sb = new StringBuilder();
    for (let i = 0; i < headValues.length; i++) {
      if (
        headValues[i] !== "" &&
        headValues[i] !== undefined &&
        headValues[i] != null
      ) {
        // 如果为空则跳过
        sb.append(headValues[i]).append(SEPARATOR);
      }
    }
    // 形如/flylog/lbtest|15bfe92e-a774-44af-baee-c66fb696668b|1517390150487|686a3851854e4e9aa9b2420f1681fdc4
    return sb.toString().substring(0, sb.toString().lastIndexOf(SEPARATOR));
  }
  /**
   * hmacsha256签名计算
   *
   * @param secret 签名密钥
   * @param url 请求完整路径
   * @param authNonce 随机数
   * @param authTimestamp 时间戳
   * @param authAppId appid
   * @param contentMD5 请求体md5
   * @return signature 签名
   */
  signature(secret, url, authNonce, authTimestamp, authAppId, contentMD5) {
    try {
      const values = [];
      values[0] = url;
      values[1] = authNonce;
      values[2] = authTimestamp;
      values[3] = authAppId;
      values[4] = contentMD5;
      const stringToSign = this.buildStringToSign(values);
      return crypto
        .createHmac("sha256", secret)
        .update(stringToSign)
        .digest()
        .toString("base64");
    } catch (e) {
      Vue.prototype.$exp("cypto:signature", e && e.message);
      throw new Error(e);
    }
  }
}

export default new FlyCrypto(GATEWAY_ENCRYPT_CONFIG);
